import React, { useContext, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from '../MainNavigation/MainNavigation.module.scss';
import { Navigation, Scrollbar } from 'swiper';
import { GlobalContext } from '../../views/pages/GlobalContext';
import { Link, useLocation } from 'react-router-dom';
import { addCustomPathToLink, generateKey, getCurrentPathname, removeLastSlashes } from '../../functions';
import { DataContext } from '../../views/pages/Root';

const MenuTiles = ({ contextData }) => {
  const swiperButtonPrevRef = useRef(null);
  const swiperButtonNextRef = useRef(null);
  const data = useContext(DataContext);
  const [tilesMenuIsActive, setTilesMenuIsActive] = useState(false);

  const renderTilesElement = (item, index) => {
    // console.log(item, index);
    const slug = !!item?.slug && item.slug.length > 1 ? `${!!item?.slugPrefix ? item.slugPrefix + '/' : ''}${item.slug}` : '/';
    const currentPageData = !!data?.pages?.length && data.pages.find((page) => !!page?.slug && page.slug.trim() == slug.trim());
    // console.log(currentPageData);
    const itemImage = !!currentPageData?.cover && currentPageData.cover;

    return (
      <SwiperSlide key={generateKey()} className={`${!itemImage ? styles.tileNoImage : ''}`}>
        <li className={!!contextData?.menuCurrentPage ? (contextData.menuCurrentPage - 1 == index ? styles.activeItem : '') : ''}>
          <Link to={addCustomPathToLink(`${slug}`)} aria-label={item.name} onClick={(_) => setTilesMenuIsActive(false)}>
            <p>{item.name}</p>
            {!!itemImage && <img className={styles.imageCategory} src={addCustomPathToLink(itemImage, true)}></img>}
          </Link>
        </li>
      </SwiperSlide>
    );
  };
  //
  // useEffect(
  //   (_) => {
  //     console.log(contextData.menuFlatStructure);
  //   },
  //   []
  // );

  // const menuStructureTilesArray = useContext(MenuTilesStructure);
  // const menuItemsNumber = useContext(MenuItemsNumber);

  return (
    !!contextData && (
      <>
        {tilesMenuIsActive && <div className={styles.hamburgerOverlay} onClick={(_) => setTilesMenuIsActive(false)}></div>}
        <div className={`${tilesMenuIsActive ? styles.activeTilesMenu : ''} ${styles.tilesMenu}`}>
          <Swiper
            scrollbar={{
              hide: true,
              draggable: true,
            }}
            navigation={{ prevEl: swiperButtonPrevRef.current, nextEl: swiperButtonNextRef.current }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = swiperButtonPrevRef.current;
              swiper.params.navigation.nextEl = swiperButtonNextRef.current;
            }}
            slidesPerView={2.3}
            spaceBetween={0}
            breakpoints={{
              390: {
                slidesPerView: 2.3,
              },
              640: {
                slidesPerView: 3.5,
              },
              860: {
                slidesPerView: 3.5,
              },
              1200: {
                slidesPerView: 5.5,
              },
              1400: {
                slidesPerView: 6.5,
              },
              1600: {
                slidesPerView: 7.5,
              },
            }}
            modules={[Navigation, Scrollbar]}
            initialSlide={!!contextData?.menuCurrentPage ? Math.max(contextData.menuCurrentPage - 4, 0) : 0}
          >
            <ul className="swiper-wrapper">
              {!!contextData?.menuFlatStructure && contextData.menuFlatStructure.map((item, index) => renderTilesElement(item, index))}
            </ul>
            <div className={styles.swiperScrollbar + ' swiper-scrollbar'}></div>
            <div ref={swiperButtonPrevRef} className={styles.swiperButtonPrev + ' swiper-button-prev'}></div>
            <div ref={swiperButtonNextRef} className={styles.swiperButtonNext + ' swiper-button-next'}></div>
          </Swiper>
          <button className={styles.btnClose} onClick={(_) => setTilesMenuIsActive(false)}></button>
        </div>
        <div className={styles.headerButtonsWrapper}>
          <button className={styles.menuBtn} onClick={(_) => setTilesMenuIsActive((prevState) => !prevState)}>
            <span>MENU</span>
          </button>
          <div className={styles.menuCount}>
            {(!!contextData?.menuCurrentPage ? contextData.menuCurrentPage : 1) +
              '/' +
              (!!contextData?.menuItemsNumber ? contextData.menuItemsNumber : '')}
          </div>
        </div>
      </>
    )
  );
};

export default MenuTiles;
